const INSTORE_REDEMPTION_TIME_IN_MINUTES = 10;
const DATABASE_DATETIME_FORMAT = "YYYY-MM-DD:HH:mm:ss";

export { INSTORE_REDEMPTION_TIME_IN_MINUTES, DATABASE_DATETIME_FORMAT };
